import { render } from "./CreateDvir.vue?vue&type=template&id=2c7c7700"
import script from "./CreateDvir.vue?vue&type=script&lang=js"
export * from "./CreateDvir.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__